<template>
  <div class="dashboard-settings">
    <div class="settings-wrapper">
      <!-- General Settings -->
      <div v-if="activeTab === 'general'">
        <h6 class="mb-3">{{ $t('dashboard_settings') }}</h6>
        <p class="text-muted mb-4 small">{{ $t('dashboard_settings_description') }}</p>

        <div class="settings-list">
          <div
            v-for="option in overviewSettings"
            :key="option.key"
            class="setting-row d-flex align-items-center justify-content-between py-3">
            <label :for="option.id" class="mb-0 me-4">
              <strong>{{ $t(option.label) }}</strong>
            </label>
            <div class="form-check form-switch mb-0">
              <input
                :id="option.id"
                v-model="settings[option.key]"
                class="form-check-input"
                type="checkbox"
                :disabled="saving"
                @change="saveSettings(option.key)">
            </div>
          </div>

          <div class="setting-row privacy-setting d-flex align-items-center justify-content-between py-3">
            <label for="hide-dashboard-values" class="mb-0 me-4">
              <strong class="d-block">{{ $t('hide_dashboard_values') }}</strong>
              <small class="text-muted">{{ $t('hide_dashboard_values_description') }}</small>
            </label>
            <div class="form-check form-switch mb-0">
              <input
                id="hide-dashboard-values"
                v-model="settings.hide_values"
                class="form-check-input"
                type="checkbox"
                :disabled="saving"
                @change="saveSettings('hide_values')">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import helper from '../../helper';

export default {
  name: 'DashboardSettings',
  props: ['activeTab'],
  data() {
    return {
      settings: {
        show_products_overview: true,
        show_pos_overview: false,
        show_sales_overview: true,
        show_purchases_overview: true,
        hide_values: false
      },
      overviewSettings: [
        {
          key: 'show_products_overview',
          id: 'show-products-overview',
          label: 'show_products_overview'
        },
        {
          key: 'show_pos_overview',
          id: 'show-pos-overview',
          label: 'show_pos_overview'
        },
        {
          key: 'show_sales_overview',
          id: 'show-sales-overview',
          label: 'show_sales_overview'
        },
        {
          key: 'show_purchases_overview',
          id: 'show-purchases-overview',
          label: 'show_purchases_overview'
        }
      ],
      saving: false
    };
  },
  computed: {
    business() {
      return this.$store.getters.BUSINESS;
    }
  },
  methods: {
    async saveSettings(settingKey) {
      try {
        this.saving = true;
        const business = this.business;
        const metadata = { ...(business.metadata || {}) };
        
        // Update metadata with dashboard settings
        metadata.dashboard_settings = {
          ...(metadata.dashboard_settings || {}),
          ...this.settings
        };
        
        // Save to backend
        await helper.customPost(`${process.env.VUE_APP_API}/businesses`, {
            metadata: metadata
        }, { showToast: true });
        
        // Update store
        this.$store.commit('SET_BUSINESS', {
            ...business,
            metadata: metadata
        });
        
      } catch (error) {
        this.settings[settingKey] = !this.settings[settingKey];
        this.$toast.error(this.$t('error_saving_settings'));
      } finally {
        this.saving = false;
      }
    },
    loadSettings() {
        const metadata = this.business?.metadata || {};
        this.settings = {
          ...this.settings,
          ...(metadata.dashboard_settings || {}),
          hide_values: metadata.dashboard_settings?.hide_values === true
        };
    }
  },
  mounted() {
    this.loadSettings();
  }
};
</script>

<style scoped>
.dashboard-settings {
  padding: 0;
}
.settings-wrapper {
  max-height: calc(80vh - 120px);
  overflow-y: auto;
  overflow-x: hidden;
}
.setting-row {
  border-bottom: 1px solid #e9ecef;
}
.setting-row label {
  cursor: pointer;
}
.setting-row .form-check-input {
  cursor: pointer;
  height: 22px;
  width: 45px;
}
.setting-row .form-check-input:disabled {
  cursor: wait;
}
.privacy-setting {
  margin-top: 0.75rem;
  border-top: 1px solid #dee2e6;
}
</style>
